module.exports = __webpack_public_path__ + "static/media/default_sound.b1514252.mp3";